import { gql } from "@apollo/client";

export const PARTNER_TYPE = gql`
	query ($operatorId: ID!, $partnerTypeId: ID, $lockerTypeIds: [Int]) {
		partnerTypes(
			operatorId: $operatorId
			partnerTypeId: $partnerTypeId
			lockerTypeIds: $lockerTypeIds
		) {
			partnerType
			partnerTypeId
			monthlyFee
			description
			partnerCategory {
				partnerCategoryNo
				partnerCategory
			}
			partnerLockerTypeAccess {
				lockerType {
					lockerType
					lockerTypeId
				}
			}
			partnerDropoffFees {
				partnerDropoffFeeId
				doorSize {
					doorSizeId
					doorSize
				}
				initialFreeHours
				dropoffFee
			}
			partnerShipoutFees {
				partnerShipoutFeeId
				doorSize {
					doorSizeId
					doorSize
				}
				commissionPercent
				initialShipoutFee
				initialFreeHours
				excessFeePerInc
				incByHours
				maxOverstayCharge
			}
			__typename
		}
	}
`;

export const ALL_PARTNER_CAREGORIES = gql`
	{
		partnerCategories {
			partnerCategory
			partnerCategoryNo
		}
	}
`;
export const CREATE_PARTNER_TYPE = gql`
	mutation (
		$operatorId: ID!
		$partnerType: String!
		$partnerCategoryNo: Int!
		$lockerTypes: [ID]!
		$description: String!
		$monthlyFee: Decimal!
	) {
		createPartnerType(
			operatorId: $operatorId
			partnerType: $partnerType
			partnerCategoryNo: $partnerCategoryNo
			lockerTypes: $lockerTypes
			description: $description
			monthlyFee: $monthlyFee
		) {
			courierType {
				partnerType
				partnerTypeId
			}
		}
	}
`;

export const UPDATE_PARTNER_TYPE = gql`
	mutation ($courierTypes: [UpdatePartnerTypeObject]!) {
		updatePartnerType(courierTypes: $courierTypes) {
			courierType {
				partnerTypeId
				partnerType
				partnerCategory {
					partnerCategoryNo
					partnerCategory
				}
				partnerLockerTypeAccess {
					lockerType {
						lockerTypeId
						lockerType
					}
				}
				description
				monthlyFee
			}
		}
	}
`;
export const LOCKER_TYPES = gql`
	{
		lockerTypes {
			lockerTypeId
			lockerType
		}
	}
`;
